(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-wrapper"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const swiperEls = document.querySelectorAll(".footer-wrapper .swiper");

  swiperEls.forEach((el) => {
    new Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 16,
     pagination: {
      el: '.footer-wrapper .swiper-pagination',
      clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        }
    },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        },
        1150: {
          slidesPerView: 3,
        },
        1151: {
          slidesPerView: 6,
          enabled: false // Disable swiper on wider screens
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
